const PagedList = require('../entities/paged-list');

const Region = require('../entities/region');

const placeCache = require('./place-id-cache');

const idField = ['id'];
const persistFields = ['id', 'osmUid'];
const detailFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality'];
const detailWithAreaFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality', 'area'];
const searchFields = ['id', 'country', 'county', 'state', 'city', 'neighbourhood', 'locality'];

class LegacyRegionsRepo {
  constructor(client
  /*: ApiClient*/
  ) {
    this.client = client;
  }

  searchAdmin({
    /*: {
        q: string,
        street: string,
        city: string,
        postalcode: string,
        country: string
      }*/

    q,
    street,
    city,
    postalcode,
    country
  } = {})
  /*: Promise<PagedList<Region>>*/
  {
    const params = {
      q,
      street,
      city,
      postalcode,
      country
    };
    const req = new this.client.Request('/regions/discover', params);
    req.parse = Region.fromJson;
    return this.client.get(req) // FIXME: Remove this when the API filters regions without ids...
    .then(pList => pList.copy(items => items.filter(region => region.osmUid !== 'undefined undefined')));
  }

  search({
    /*: {
        query: string
      }*/

    query
  } = {})
  /*: Promise<PagedList<Region>>*/
  {
    const params = {
      q: query
    };
    const path = '/regions/search';
    const req = new this.client.Request(path, params, searchFields);
    req.parse = Region.fromJsonSimple;
    return this.client.get(req);
  }

  persist(region
  /*: Region*/
  )
  /*: Promise<Region>*/
  {
    // Already persisted...
    if (region.id) return Promise.resolve(region); // Already cached...

    const cachedRegion = placeCache.getItem(region.osmUid);
    if (cachedRegion) return Promise.resolve(cachedRegion);
    const params = {
      token: region.token
    };
    const req = new this.client.Request(`/regions`, params, persistFields);

    req.parse = json => new Region(json);

    return this.client.post(req).then(persistedRegion => {
      placeCache.setItem(region.osmUid, persistedRegion);
      return persistedRegion;
    });
  }

  details(regionId
  /*: string*/
  )
  /*: Promise<Region>*/
  {
    const req = new this.client.Request(`/regions/${regionId}`, {}, detailFields);

    req.parse = json => {
      const region = new Region(json); // Being `complete` is a prerequisite for being persisted (ie: having an id at all)

      region.isComplete = true;
      return region;
    };

    return this.client.get(req);
  }

  detailsWithArea(regionId
  /*: string*/
  )
  /*: Promise<Region>*/
  {
    const req = new this.client.Request(`/regions/${regionId}`, {}, detailWithAreaFields);

    req.parse = json => new Region(json);

    return this.client.get(req);
  }

  multiDetails(regionIds
  /*: Array<string>*/
  )
  /*: Promise<PagedList<Region>>*/
  {
    return Promise.all(regionIds.map(id => this.details(id))).then(regions => new PagedList(regions));
  }

  update(region
  /*: Region*/
  )
  /*: Promise<Region>*/
  {
    if (!region.id) throw new Error('Cannot update non-persisted Region');
    const req = new this.client.Request(`/regions/${region.id}`, {
      token: region.token
    }, idField);

    req.parse = json => new Region(json);

    return this.client.post(req);
  }

}

module.exports = LegacyRegionsRepo;